import React from 'react'

import { Button } from './styles'

import Icon from '../../../../components/icon'
import { CONTACT_NUMBER } from '../../../../helpers'

const WhatsappButton = () => (
  <Button
    href={`https://wa.me/${CONTACT_NUMBER}?text=Olá! Estou com dúvidas sobre a plataforma.`}
    target="_blank"
  >
    <Icon name="whatsapp" />
    Fale Conosco
  </Button>
)

export default WhatsappButton
